export default "__VITE_ASSET__DXQ56yM0__";